import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14',
  '3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4',
  '2 12.6667 2ZM12.6667 12.6667H3.33333V3.33333H12.6667V12.6667ZM4.66667',
  '6.66667H6V11.3333H4.66667V6.66667ZM7.33333 4.66667H8.66667V11.3333H7.33333V4.66667ZM10',
  '8.66667H11.3333V11.3333H10V8.66667Z',
].join(' ');

export const IconChart = ({ width = 16, height = 16, color, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color || 'currentColor'} />
  </Svg>
);

export default IconChart;
